import React from "react";
import {
    Box,
    Button,
    Center,
    Flex,
    Heading,
    VStack,
} from "@chakra-ui/react";
import "../Landing/Landing.scss";
import { teamMembers } from "../../constants";

interface TeamProps {
    onBack: () => void;
}

const getInitials = (name: string) =>
    name
        .split(" ")
        .slice(0, 2)
        .map((n) => n[0])
        .join("")
        .toUpperCase();

const Team: React.FC<TeamProps> = ({ onBack }) => {
    return (
        <Box
            h="100vh"
            w="100%"
            position="relative"
            className="landing__header"
            overflowY="auto"
        >
            <Button
                position="absolute"
                top={4}
                left={4}
                variant="ghost"
                color="white"
                _hover={{ bg: "whiteAlpha.200" }}
                onClick={onBack}
                zIndex={1}
            >
                ← Regresar
            </Button>

            <Center h="100%" pt={16} pb={8}>
                <VStack spacing={12} w="100%" px="8vw">
                    <Heading
                        as="h1"
                        color="white"
                        letterSpacing="0.2em"
                        textAlign="center"
                        style={{ fontSize: "5vw" }}
                    >
                        EQUIPO
                    </Heading>

                    <Flex flexWrap="wrap" gap={6} justify="center" w="100%">
                        {teamMembers.map((member, i) => (
                            <VStack
                                key={i}
                                w={[
                                    "calc(50% - 12px)",
                                    "calc(33.33% - 16px)",
                                    "calc(25% - 18px)",
                                ]}
                                bg="blackAlpha.300"
                                borderRadius="xl"
                                py={8}
                                px={4}
                                spacing={4}
                                backdropFilter="blur(6px)"
                                border="1px solid"
                                borderColor="blackAlpha.100"
                                transition="background 0.2s"
                            >
                                <Center
                                    w="3.5vw"
                                    h="3.5vw"
                                    minW="48px"
                                    minH="48px"
                                    borderRadius="full"
                                    bg="whiteAlpha.300"
                                    border="1px solid"
                                    borderColor="whiteAlpha.500"
                                >
                                    <Heading
                                        as="span"
                                        color="white"
                                        fontSize="1.2vw"
                                    >
                                        {getInitials(member.name)}
                                    </Heading>
                                </Center>
                                <Heading
                                    as="h3"
                                    fontSize="1.1vw"
                                    color="white"
                                    textAlign="center"
                                    letterSpacing="0.05em"
                                    fontWeight="500"
                                >
                                    {member.name}
                                </Heading>
                            </VStack>
                        ))}
                    </Flex>
                </VStack>
            </Center>
        </Box>
    );
};

export default Team;
